<template>

    <system-alerts></system-alerts>
    <div class="container-fluid"
        v-if="audit != undefined">

        <ul class="nav nav-tabs"
            id="myTab"
            role="tablist">
            <li v-for="tab in tabs"
                class="nav-item"
                role="presentation"
                :key="tab.id">
                <button class="nav-link"
                    :class="{ active: tab.id==selectedTab }"
                    data-bs-toggle="tab"
                    :data-bs-target="`#${tab.id}`"
                    type="button"
                    role="tab"
                    @click.prevent="selectedTab=tab.id"
                    :aria-controls="tab.id"
                    aria-selected="true">{{ tab.name }}</button>
            </li>
        </ul>

        <div class="tab-content">
            <div class="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="home-tab"
                tabindex="0">

                <audit-details-general :run-audits="runAudits"
                    @reload="getData"
                    :create-audits="createAudits"
                    :audit="audit"
                    :id="id" />
            </div>
            <div class="tab-pane fade"
                id="documents"
                role="tabpanel"
                aria-labelledby="profile-tab"
                tabindex="0">
                <audit-details-documents :url="url"
                    :run-audits="runAudits"
                    :create-audits="createAudits"
                    :audit="audit"
                    :id="id" />
            </div>
            <div class="tab-pane fade"
                id="incidents"
                role="tabpanel"
                aria-labelledby="contact-tab"
                tabindex="0">

                <audit-details-incidents :url="url"
                    :run-audits="runAudits"
                    :create-audits="createAudits"
                    :audit="audit"
                    :id="id" />

            </div>

            <div class="tab-pane fade"
                id="comments"
                role="tabpanel"
                aria-labelledby="disabled-tab"
                tabindex="0">
                <audit-details-comments :run-audits="runAudits"
                    :create-audits="createAudits"
                    :audit="audit"
                    :id="id" />
            </div>
        </div>

    </div>

    <div class="container-fluid"
        v-else>
        <div class="header w-100 text-center">
            <h3 class="mx-auto">Loading...</h3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { Audit } from "@/audit.types";
import SystemAlerts from "./Misc/SystemAlerts.vue";
import AuditDetailsDocuments from "./AuditDetails/AuditDetailsDocuments.vue";
import AuditDetailsIncidents from "./AuditDetails/AuditDetailsIncidents.vue";
import AuditDetailsComments from "./AuditDetails/AuditDetailsComments.vue";
import AuditDetailsGeneral from "./AuditDetails/AuditDetailsGeneral.vue";

import { useAuditStore } from "@/stores/auditStore";

const props = defineProps({
    id: Number,
    runAudits: Boolean,
    createAudits: Boolean,
});
const selectedTab = ref("general");
const tabs = [
    { name: "General", id: "general" },
    { name: "Documents", id: "documents" },
    { name: "Incidents", id: "incidents" },
    { name: "Comments", id: "comments" },
];
const auditStore = useAuditStore();

const audit = ref<Audit>({} as Audit);

const getData = async function () {
    var item = await auditStore.getById(props.id!);
    audit.value = item;
};
await getData();
</script>
